import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fake-users',
  templateUrl: './fake-users.component.html',
  styleUrls: ['./fake-users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FakeUsersComponent implements OnInit {
  public arrCoupons: any[] = [];
 
  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router, 
    private toastr : ToastrService, 
    private loading: LoadingService,
        private modal : NgbModal, 
        private language : LanguageService,
         private route: ActivatedRoute
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
  public userData : any

 
  public levels: any[] = [];
  public tempData = [];
  public fakeUsers:any

  public lang : any
public showSuccessAfterLoad = false;

  @ViewChild(DatatableComponent) table: DatatableComponent;

 

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.language.currentLang.subscribe((res: string) => {
      this.lang = res;
    })
    // this.fakeUsersList()


    
      this.route.queryParams.subscribe(params => {
    if (params['success'] === 'true') {
      this.showSuccessAfterLoad = true;

      // Remove the success param immediately
      this.router.navigate([], {
        queryParams: { success: null },
        queryParamsHandling: 'merge',
        replaceUrl: true // to prevent navigation history
      });
    }

    this.fakeUsersList(); // 🔁 move inside the queryParams logic to ensure order
  });
  }

      /*----------  Translating genders  ----------*/
  translateGender(gender) {
    if (gender == 'Male') {
      return 'ذكر';
    } else {
      return 'أنثى';
    }
  }
 
fakeUsersList() {
  this.loading.show();
  this.apisService.getFakeUsers(this.currentPage).subscribe({
    next: (res) => {
      this.fakeUsers = res.data;
      this.loading.hide();

      // ✅ Only show SweetAlert AFTER loader is hidden
      if (this.showSuccessAfterLoad) {
        this.showSuccessAfterLoad = false; // reset the flag
        setTimeout(() => {
          Swal.fire(
            'تم بنجاح',
            'تم حفظ المستخدم الوهمي بنجاح',
            'success'
          );
        }, 100); // slight delay to ensure hide animation completes
      }
    },
    error: (err) => {
      console.log('error in fetching', err);
      this.loading.hide();
    }
  });
}


 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

  
  /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }

  
  /*----------  Show fake user Data  ----------*/
  showFakeUserData(id){
    this.apisService.userDetails(id).subscribe({
      next: (res) => {
        
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
      }
    })
  }
  

  
  /*----------  detele fake users  ----------*/
  deleteFakeUser(id){
    this.apisService.deleteFakeUsers(id).subscribe({
      next: (res) => {
        this.fakeUsersList()
        this.toastr.success("Deleted Successfully", "Success")
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
      }
    })
  }
  
    getFakeUserById(id: any) {
    this.apisService.getFakeUserById(id).subscribe({
      next: (res) => {
        this.userData = res.data
        console.log(this.userData)
        this.loading.hide()
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
        this.loading.hide()
      }
    })
  }


  /*=============================================
=            Modal functions            =
=============================================*/
open(content : any , row : any){ 
  this.loading.show()
  this.modal.open(content, { centered: true , size: 'md' });
  this.getFakeUserById(row.id)
}

close(){
  this.modal.dismissAll();
}

/*=====  End of Modal functions  ======*/


/*----------  Pagination Functions   ----------*/
next(){ 
  this.currentPage++
  this.fakeUsersList()
}

prev(){ 
  this.currentPage--
  this.fakeUsersList()
}

/*----------  Background color for gender  ----------*/
getRowClass = (row: any) => {
  return row.user_gender === 'Female' ? 'female-row' : '';
};



}
